import React from 'react'
import { makeStyles } from '@mui/styles'

import i18nUiComponents from '../../locales/i18n'
import { ClassesType, Nil } from '../../types'
import Text, { TextProps } from '../Text'
import { useHtmlPreview } from './useHtmlPreview'

const useStyles = makeStyles(
  () => ({
    text: {},
    previewContainer: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
  }),
  { name: 'HtmlNotesPreview' },
)

export interface HtmlNotesPreviewProps {
  readonly allowPointerEvents?: boolean
  readonly classes?: ClassesType<typeof useStyles>
  readonly css?: string
  readonly fontSize?: string
  readonly includeLabel?: boolean
  readonly inlineLabel?: boolean
  readonly label?: string
  readonly notes?: string | Nil
  readonly strong?: boolean
  readonly variant?: TextProps['variant']
}

export const HtmlNotesPreview = ({
  css,
  classes: classesProp,
  notes,
  includeLabel = false,
  inlineLabel = false,
  label,
  allowPointerEvents = true,
  fontSize = '1.6rem',
  strong,
  variant,
}: HtmlNotesPreviewProps) => {
  const classes = useStyles({ classes: classesProp })

  const htmlNotesPreviewLabel =
    label || i18nUiComponents.t<string>('Common:NOTES')

  const inlineLabelHtml = `<span style="margin-right:4px;font-weight:${
    strong ? 500 : 400
  };font-size:${fontSize}">${htmlNotesPreviewLabel}:</span>`

  const htmlPreview = useHtmlPreview({
    css,
    html: inlineLabel ? inlineLabelHtml + notes : notes,
    allowPointerEvents,
    shadowDomClasses: { previewContainer: classes.previewContainer },
    fontSize,
  })

  return (
    <>
      {includeLabel && (
        <Text
          className={classes.text}
          fontSize={fontSize}
          strong={strong}
          variant={variant}
        >
          {htmlNotesPreviewLabel}:
        </Text>
      )}
      {htmlPreview}
    </>
  )
}
